import { Navigate, Route, Routes } from 'react-router-dom';

import QuestionnaireIntroduction from '../common/components/QuestionnaireIntroduction';
import {
  ONBOARDING_INTRODUCTION_VIDEO_POSTER,
  ONBOARDING_INTRODUCTION_VIDEO_SRC,
} from '../common/constants';
import {
  AgreementForm,
  GeneralInformationForm,
  PrimaryInsuranceForm,
  ReferralForm,
  SecondaryInsuranceForm,
  SubmitForm,
} from './components/forms';
import { ONBOARDING_TAB_IDS } from './constants';

export default function OnboardingQuestionnaireRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate replace to={ONBOARDING_TAB_IDS.INTRODUCTION} />} />
      <Route
        path={ONBOARDING_TAB_IDS.INTRODUCTION}
        element={
          <QuestionnaireIntroduction
            src={ONBOARDING_INTRODUCTION_VIDEO_SRC}
            poster={ONBOARDING_INTRODUCTION_VIDEO_POSTER}
          />
        }
      />
      <Route path={ONBOARDING_TAB_IDS.GENERAL} element={<GeneralInformationForm />} />
      <Route path={ONBOARDING_TAB_IDS.PRIMARY_INSURANCE} element={<PrimaryInsuranceForm />} />
      <Route path={ONBOARDING_TAB_IDS.SECONDARY_INSURANCE} element={<SecondaryInsuranceForm />} />
      <Route path={ONBOARDING_TAB_IDS.REFERRAL} element={<ReferralForm />} />
      <Route path={ONBOARDING_TAB_IDS.AGREEMENT} element={<AgreementForm />} />
      <Route path={ONBOARDING_TAB_IDS.SUBMIT} element={<SubmitForm />} />
      <Route path="*" element={<Navigate replace to={ONBOARDING_TAB_IDS.INTRODUCTION} />} />
    </Routes>
  );
}
